import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup} from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/core/services/common.service';
import { AppealService } from 'src/app/core/services/appeal.service';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-appeal-historical',
  templateUrl: './appeal-historical.component.html',
  styleUrls: ['./appeal-historical.component.css']
})
export class AppealHistoricalComponent implements OnInit {

  isArabic!: boolean;
    @Input() appealList: any;
    userData: any;
    form!: FormGroup;
    appealDetail: any[] = [];
    appealId?: string;  
  
     constructor( private router: Router,              
      private storageService: StorageService,
      private commonService: CommonService,
      private fb: FormBuilder,
      private appealService: AppealService
      ) { }
  
    ngOnInit(): void {
       this.isArabic = this.storageService.getSessionStorageData('isArabic');

       this.form = this.fb.group({
        enforcement: ['']
      });
  
     
       this.userData = this.storageService.getSessionStorageData('userDetails');
      const requestData = {
        assessmentUnitGuid: this.userData?.assessmentUnitValue,
      };
  
      this.appealService.fetchAppealHistory(requestData).subscribe(
        (res) => {
          if (res?.data) {
            const decryptedData = this.commonService.decryptUsingAES256(res?.data);
            const SUBMITTED_STATUS_CODE = 755020001;
            const APPROVED_STATUS_CODE = 755020002; 
            const PARTIALLY_APPROVED_STATUS_CODE = 755020003;
            const REJECTED_STATUS_CODE = 755020004; 
            const INTERNAL_REVIEW = 755020005; 

            // The array to filter the records you want to keep
            const filteredRecords = decryptedData.filter((item: any) => 
              item.mde_appealstatus === SUBMITTED_STATUS_CODE || 
              item.mde_appealstatus === APPROVED_STATUS_CODE || 
              item.mde_appealstatus === PARTIALLY_APPROVED_STATUS_CODE ||
              item.mde_appealstatus === REJECTED_STATUS_CODE || 
              item.mde_appealstatus === INTERNAL_REVIEW
            );
            this.appealDetail = JSON.parse(JSON.stringify(filteredRecords));
          }
        },
        (error: any) => {
          console.error('Error fetching appeal detail', error);
        }
      );
    
     
    }
  
      subscribeToEmitter(componentRef: any) {
        // if (!(componentRef instanceof  AssessmentSelectComponent)) {
        //   return;
        // }
        // const child: any = componentRef;
       
      
      }
   
     onListItemClick(selectedItemIdx: number) {
      this.appealList.forEach((v: any, i: any) => {
        if (i === selectedItemIdx) {
          v.isActive = true;
        } else {
          v.isActive = false;
        }
      });
       if (this.appealList[selectedItemIdx].link !== '') {
        let path = 'executor-dashboard/' + this.appealList[selectedItemIdx].link;
        this.router.navigate([path]);
      }
    }

    goToDetail(appealId: string) {
      if (appealId) {
        this.storageService.setSessionStorageData('appealId', appealId);
        this.storageService.setSessionStorageData('appealHistorical', true);
        this.router.navigate(
          ['/executor-dashboard/appeal/detail'],
          { state: { appealId: appealId, appealHistorical: true } }
        );
      } else {
        alert(this.isArabic ? 'يرجى تحديد التقييم أولاً.' : 'Please select an assessment first.');
      }
    }
  
  }
